import builder from './builder'
import cclone from './cclone'
import dsp from './dsp'
import coverClose from './coverClose'
import dataEntry from './dataEntry'
import georadar from './georadar'
import manageTaxonomy from './manageTaxonomy'
import secondParty from './secondParty'
import migration from './migration'
import monitoring from './monitoring'
import settings from './settings'
import transfers from './transfers'
import volumeAlert from './volumeAlert'

const state = {}

export default {
    namespaced: true,
    state,
    modules: {
        builder,
        cclone,
        dsp,
        secondParty,
        coverClose,
        dataEntry,
        georadar,
        manageTaxonomy,
        migration,
        monitoring,
        settings,
        transfers,
        volumeAlert
    }
}
